import 'react-on-rails-pro/registerDefaultRSCProvider/client';
import ReactOnRails from 'react-on-rails-pro/client';
import BlogPostClient from '../../startup/BlogPostClient.client.tsx';

ReactOnRails.register({BlogPostClient});